import axios from 'axios'

export default class Authenticator {
  private readonly hash: string
  private readonly password: string
  constructor(hash: string, password: string) {
    this.hash = hash
    this.password = password || ''
  }

  auth() {
    const client = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
      headers: {
        'Content-Type': 'application/json',
        'Origin': window.location.origin,
      },
      responseType: 'json'
    })
    return client.post<responseAuth>('/auth', {
      hash: this.hash,
      password: this.password,
    })
  }
}
